// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Tooltip, Typography, TypographyProps } from '@mui/material';

interface Props extends TypographyProps {
  /**
   * The tooltip title for the typography.
   */
  tooltip: string;
}

/**
 * A underlined typography component that displays a tooltip when hovered.
 */
export function TooltipTypography(props: Props) {
  const { tooltip, ...typographyProps } = props;

  return (
    <Tooltip arrow title={tooltip}>
      <Typography
        sx={{ textDecorationLine: 'underline', textDecorationStyle: 'dotted' }}
        {...typographyProps}
      >
        {props.children}
      </Typography>
    </Tooltip>
  );
}
